import { makeStyles } from "@material-ui/core";

export const widgetTitleStyle = makeStyles((theme) => ({
    widgetTitle: {
        color: theme.palette.primary.dark,
        fontWeight: '500',
        paddingLeft: '1.5rem',
        fontSize: 16,
    },
    mechDashTitleStyle: {
        color: theme.palette.primary.dark,
        marginTop: '0',
        fontWeight: 500,
        fontSize: 17
    },
    header: {
        paddingTop: '1rem',
        paddingLeft: '0.5rem',
        width: '100%'
    },
    filterIcon: {
        '& path': {
            fill: theme.palette.primary.main,
            stroke: theme.palette.primary.main
        }
    },
    filters: {
        padding: '1rem',
        minWidth: '20vw',
        maxWidth: '20vw',
    },
    badge: {
        backgroundColor: '#ff5555'
    },
}));